import template from './price-comparison.html';
import './price-comparison.global.css';

export const PriceComparisonComponent = {
  template,
  bindings: {
    original: '<',
    reduced: '<',
  },
};
